export const DRACO_URL =
  "https://www.gstatic.com/draco/versioned/decoders/1.4.0/";
